export enum TrackingServices {
    GoogleAnalytics = 1,
    Amplitude,
    Intercom,
}

export enum CampaignsAction {
    SingleEventCampaignClick = 'Create Single Event Invite',
    MultiEventCampaignClick = 'Create Multi Event Campaign',
    CampaignCreated = 'CampaignCreated',
    CampaignView = 'CampaignView',
    CampaignSentWithEvents = 'Campaign Sent With Events',
    CampaignSentWithoutEvents = 'Campaign Sent Without Events',
    NewsletterErrorClick = 'NewsletterErrorClick',
}

export enum SegmentationReportAction {
    CampaignSubjectChanged = 'Segmentation Campaign Subject Changed',
    CampaignSentImmediately = 'Segmentation Campaign Sent Immediately',
    CampaignScheduledSend = 'Segmentation Campaign Scheduled Send',
    SelectedSegment = 'segment was selected',
    ExportedCsv = 'Delivery Report CSV exported',
    ClickedDeliveryReport = 'Clicked on Delivery Report for email campaign',
    ClickedRetargetCta = 'Clicked on Retarget subscribers CTA',
    HasUsedSegmentationReport = 'Has Used Segmentation Report',
    SegmentationCTABannerClicked = 'Segmentation CTA Banner Clicked',
}

export enum EventsAction {
    EventCardClick = 'Clicked Event Card Rec',
}

export enum AnalyticsCategory {
    default = 'MarketingTools',
    EmailCampaigns = 'EmailCampaigns',
    EventbriteBoost = 'EventbriteBoost',
}

export enum IntercomUpdateKey {
    ClickedSingleEventEmail = 'ClickedSingleEventEmail',
    ClickedMultiEventEmail = 'ClickedMultiEventEmail',
}

export * as HeapAttributes from './heap-atributes';
